module.exports = __webpack_public_path__ + "static/media/Vector.3b72a214.svg";